import { environment } from './../environments/environment';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { Observable } from 'rxjs';
import { Cart, CartStatus } from './cart.model';
import { BaseEntityService } from "./base-entity.service";
import { AngularFirestore } from "@angular/fire/firestore";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class CartService extends BaseEntityService<Cart> {
  constructor(db: AngularFirestore) {
    super(db, Cart, "/", "carts");
  }

  listWhereStatus(status: CartStatus): Observable<Cart[]> {
    this.log("listWhereStatus", status);
    return this.list(ref => ref.where('status', '==', status));
  }

  listWhereEmail(email: string): Observable<Cart[]> {
    this.log("listWhereEmail", email);
    return this.list(ref => ref.where('email', '==', email));
  }

  listWhereNdaysLteZeroOrNdaysGtMaxNdays(): Observable<Cart[]> {
    this.log("listWhereNdaysLteZeroOrNdaysGteMaxNdays");
    const a = this.list(ref => ref.where('nDays', '<=', 0));
    const b = this.list(ref => ref.where('nDays', '>', environment.maxNdays));

    return combineLatest([a, b])
      .pipe(
        map((abItems) => {
          const [aItems, bItems] = abItems;
          return [
            ...aItems,
            ...bItems
          ];

        }));
  }
}
